import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectLoading, selectLibrary, selectLoaded } from '../selectors/library.selector';
import { libraryActions } from '../actions/library.actions';

@Injectable({
    providedIn: 'root',
})
export class LibraryFacade {
    private store = inject(Store);

    readonly loaded$ = this.store.select(selectLoaded);
    readonly loading$ = this.store.select(selectLoading);
    readonly library$ = this.store.select(selectLibrary);

    readonly loaded = this.store.selectSignal(selectLoaded);
    readonly loading = this.store.selectSignal(selectLoading);
    readonly library = this.store.selectSignal(selectLibrary);

    clear(): void {
        this.store.dispatch(libraryActions.clear());
    }
}
